import { useEdTechProductStore } from '@ninjacart/nc-nk-store';
import paths from '../paths';
import { EdTechKisaanClient } from './edTechKisanClient';
export const getProductList = async (payload: object) => {
  try {
    const response = await EdTechKisaanClient.get(paths.getProductList());
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getProductListPagination = async (ctaEndpoint: string, limit: number, offset: number) => {
  try {
    // Append limit and offset as query parameters
    const url = `${ctaEndpoint}?limit=${limit}&offset=${offset}`;
    const response = await EdTechKisaanClient.get(url);    
    return response.data;
  } catch (e) {
    console.error('API error:', e);
    throw e;
  }
};
